import { createFileRoute } from '@tanstack/react-router'
import { ChatPage } from '@/components/ai/chat-page'

export const Route = createFileRoute('/_app/chat')({
  component: ChatPageRoute,
})

function ChatPageRoute() {
  return <ChatPage />
}
